"use client";

// Libraries
import Image from "next/image";
import { Link } from "@/i18n/navigation";
import { useTranslations } from "next-intl";

export default function CreatorCard({ creator, ...props }) {
    const t = useTranslations();
    return (
        <>
            <div
                className={`${
                    props.small
                        ? "md:items-center"
                        : "md:items-center md:flex-row flex-col"
                } ${
                    props.small
                        ? "gap-3 px-4 py-3 inline-flex hover:bg-primary/5 dark:hover:bg-primary/10 duration-100"
                        : "gap-5 p-5 flex"
                } rounded-2xl border dark:border-borderDark bg-transparent lg:max-w-lg lg:w-auto w-full`}
            >
                <div>
                    <div
                        className={`${
                            props.small
                                ? "w-[30px] h-[30px]"
                                : "w-[100px] h-[100px]"
                        } rounded-full overflow-hidden`}
                    >
                        <Image
                            src={creator.photo}
                            width={props.small ? 30 : 100}
                            height={props.small ? 30 : 100}
                            alt={`${creator.firstName} ${creator.lastName}`}
                            className="rounded-full object-cover overflow-hidden"
                        />
                    </div>
                </div>
                <div className="w-full">
                    <div
                        className={`dark:text-white ${
                            props.small
                                ? "text-sm text-black dark:text-lightBlue"
                                : "text-lg font-bold"
                        } text-left `}
                    >
                        {creator.firstName} {creator.lastName}
                    </div>
                    {!props.small && (
                        <>
                            <div className="dark:text-lightBlue">
                                {creator.bio}
                            </div>
                            <div className="mt-4 flex">
                                <Link
                                    href={`/@${
                                        creator.pseudo
                                            ? creator.pseudo
                                            : `believer-${creator.id}`
                                    }`}
                                >
                                    <div className="inline-flex items-center gap-1 text-sm">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="1em"
                                            height="1em"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                fill="currentColor"
                                                fillRule="evenodd"
                                                d="M8.512 4.43a.75.75 0 0 1 1.057.082l6 7a.75.75 0 0 1 0 .976l-6 7a.75.75 0 0 1-1.138-.976L14.012 12L8.431 5.488a.75.75 0 0 1 .08-1.057Z"
                                                clipRule="evenodd"
                                            ></path>
                                        </svg>
                                        {t("CreatorCard_link_to_profile")}
                                    </div>
                                </Link>
                            </div>
                        </>
                    )}
                </div>
            </div>
        </>
    );
}
